import React, {
  createContext,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import NotificationSystem from "react-notification-system";

export const NotificationContext = createContext({});
export const NotificationProvider = ({ children }) => {
  const notificationSystem = useRef();

  const addNotification = useCallback(({ title, message, level }) => {
    const notification = notificationSystem.current;
    if (!notification) return;
    notification.addNotification({
      title,
      message,
      level,
    });
  }, []);

  const value = useMemo(() => ({ addNotification }), [addNotification]);

  return (
    <NotificationContext.Provider value={value}>
      <NotificationSystem ref={notificationSystem} />
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);